import api from "@/utils/api";

export const state = {
  _items: [],
  _item: null,
};

export const mutations = {
  setRefundList(state, items) {
    state._items = items;
  },
  setRefundDetail(state, item) {
    state._item = item;
  },
};

export const actions = {
  async acRefundList({ commit }, { status }) {
    try {
      const params = {};
      if (status) params.status = status;
      const res = await api.get("/api/v1/refund-request", { params });
      if (res.data?.code === 0) {
        commit("setRefundList", res.data.items || []);
        return { success: true };
      }
      return { success: false, message: res.data?.message || "조회 실패" };
    } catch (error) {
      console.error("[refund] list error:", error);
      return { success: false, message: error?.data?.message || "서버 오류" };
    }
  },

  async acRefundDetail({ commit }, { seq }) {
    try {
      const res = await api.get(`/api/v1/refund-request/${seq}`);
      if (res.data?.code === 0 && res.data.items?.length > 0) {
        commit("setRefundDetail", res.data.items[0]);
        return { success: true };
      }
      return { success: false, message: res.data?.message || "조회 실패" };
    } catch (error) {
      console.error("[refund] detail error:", error);
      return { success: false, message: error?.data?.message || "서버 오류" };
    }
  },

  async acRefundIssueTicket(_, { refund_request_seq }) {
    try {
      const res = await api.patch("/api/v1/refund-request/issue-ticket", { refund_request_seq });
      return { success: res.data?.code === 0, message: res.data?.message };
    } catch (error) {
      return { success: false, message: error?.data?.message || "이용권 발급 실패" };
    }
  },

  async acRefundPartialRefund(_, { refund_request_seq }) {
    try {
      const res = await api.patch("/api/v1/refund-request/partial-refund", { refund_request_seq });
      return { success: res.data?.code === 0, message: res.data?.message };
    } catch (error) {
      return { success: false, message: error?.data?.message || "부분환불 실패" };
    }
  },

  async acRefundFullRefund(_, { refund_request_seq }) {
    try {
      const res = await api.patch("/api/v1/refund-request/full-refund", { refund_request_seq });
      return { success: res.data?.code === 0, message: res.data?.message };
    } catch (error) {
      return { success: false, message: error?.data?.message || "전액환불 실패" };
    }
  },

  async acRefundCancelSubscription(_, { refund_request_seq }) {
    try {
      const res = await api.patch("/api/v1/refund-request/cancel-subscription", { refund_request_seq });
      return { success: res.data?.code === 0, message: res.data?.message };
    } catch (error) {
      return { success: false, message: error?.data?.message || "구독 취소 실패" };
    }
  },

  async acRefundChatLogs(_, { seq }) {
    try {
      const res = await api.get(`/api/v1/refund-request/${seq}/chat-logs`);
      if (res.data?.code === 0) {
        return { success: true, data: res.data.items };
      }
      return { success: false, message: res.data?.message || "채팅 로그 조회 실패" };
    } catch (error) {
      console.error("[refund] chat-logs error:", error);
      return { success: false, message: error?.data?.message || "서버 오류" };
    }
  },

  async acRefundPaymentHistory(_, { seq }) {
    try {
      const res = await api.get(`/api/v1/refund-request/${seq}/payment-history`);
      if (res.data?.code === 0 && res.data.items?.length > 0) {
        return { success: true, data: res.data.items[0] };
      }
      return { success: false, message: res.data?.message || "결제이력 조회 실패" };
    } catch (error) {
      console.error("[refund] payment-history error:", error);
      return { success: false, message: error?.data?.message || "서버 오류" };
    }
  },

  /**
   * NZSC-2790: 관리자 row-클릭 환불 실행.
   * pay_order는 서버가 400으로 막으므로 프론트에서 도비 페이지로만 안내 (action 호출 X).
   * @returns { success, data?, code?, message?, status? } — 에러 카탈로그 분기를 위해 code/status 노출
   */
  async acQuickRefund(_, { refund_request_seq, item_type, item_seq, amount, reason }) {
    try {
      const res = await api.post("/api/v1/refund-request/quick-refund", {
        refund_request_seq,
        item_type,
        item_seq,
        amount,
        reason,
      });
      if (res.data?.code === 0) {
        return { success: true, data: res.data.data, message: res.data.message };
      }
      return {
        success: false,
        code: res.data?.code,
        message: res.data?.message || "환불 실패",
      };
    } catch (error) {
      // api wrapper 에러 포맷에서 body/status 추출
      const status = error?.status || error?.response?.status;
      const body = error?.data || error?.response?.data || {};
      return {
        success: false,
        status,
        code: body.code,
        message: body.message || body.pgResponseCode || "환불 요청 실패",
      };
    }
  },

  async acRefundReject(_, { refund_request_seq, reject_reason }) {
    try {
      const res = await api.patch("/api/v1/refund-request/reject", {
        refund_request_seq,
        reject_reason,
      });
      return { success: res.data?.code === 0, message: res.data?.message };
    } catch (error) {
      return { success: false, message: error?.data?.message || "반려 실패" };
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
